import React, {
  useState,
  useEffect,
  Fragment,
  useMemo,
  useCallback,
} from "react";
import Select from "react-select";
import { ToastContainer } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import swal from "sweetalert";

import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import validator from "validator"; //https://www.npmjs.com/package/validator
import PageTitle from "../../layouts/PageTitle";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Toastr from "../../components/common/Toastr";
import Table from "../../components/table/ReactTable/Table";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import CommonService from "../../../services/Common/CommonService";

import { clientActions, masterActions } from "../../../_store";

const ClientList = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------

  const currentUser = useSelector((x) => x.auth.user);
  const stateDrpList = useSelector((x) => x.master.stateDrpList);
  const countryDrpList = useSelector((x) => x.master.countryDrpList);
  const clientTypeDrpList = useSelector((x) => x.master.clientTypeDrpList);
  const clientQuotaDrpList = useSelector((x) => x.master.clientQuotaDrpList);
  const clientDataList = useSelector((x) => x.client.clientList);
  const client = useSelector((x) => x.client.client);
  const clientResponse = useSelector((x) => x.client.clientResponse);
  const deleteClientResponse = useSelector(
    (x) => x.client.deleteClientResponse
  );
  const isLoading = useSelector((x) => x.client.isLoading);

  // #endregion ------------------  Reducer End --------------------------------

  const CLIENT_COLUMNS = [
    {
      Header: "Company Name",
      Footer: "Company Name",
      accessor: "CompanyName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Email ID",
      Footer: "Email ID",
      accessor: "EmailID",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Contact Number",
      Footer: "Contact Number",
      accessor: "ContactNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Client Type",
      Footer: "Client Type",
      accessor: "ClientTypeName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Client Quota",
      Footer: "Client Quota",
      accessor: "ClientQuotaName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      justify: "left",
      fieldType: "Date",
      // Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "ClientID",
      disableFilters: true,
      Cell: ({ value }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(value)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(value)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => CLIENT_COLUMNS, []);

  const generateColumns = [
    {
      header: "Company Name",
      dataKey: "CompanyName",
    },
    {
      header: "Email ID",
      dataKey: "EmailID",
    },
    {
      header: "Contact Number",
      dataKey: "ContactNumber",
    },
    {
      header: "Client Type",
      dataKey: "ClientTypeName",
    },
    {
      header: "Client Quota",
      dataKey: "ClientQuotaName",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  //Add State
  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submittedShipping, setSubmittedShipping] = useState(false);
  const [isOpenShippingModal, setOpenShippingModal] = useState(false);
  const [startEndDate, setStartEndDate] = useState({
    FromDate: new Date(),
    ToDate: new Date(),
    Status: 0,
  });
  const [stateList, setStateList] = useState([]);
  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  const [addFormData, setAddFormData] = useState({
    ClientID: 0,
    CompanyName: "",
    ContactNumber: "",
    ClientTypeID: 0,
    ClientTypeOption: null,
    ClientQuotaID: 0,
    ClientQuotaOption: null,
    EmailID: "",
    BillingAddress: "",
    BillingCountryID: 0,
    BCountryOption: null,
    BStateOption: null,
    BillingStateID: 0,
    BillingCity: "",
    ClientSince: null,
    BillingZipCode: "",
    AccountingPOC: "",
    TaxID: "",
    FacebookLink: "",
    TwitterLink: "",
    InstagramLink: "",
    SnapchatLink: "",
    TittokLink: "",
    Others: "",
    IsEmailIDValid: true,
    IsContactNumberValid: true,
    IsBillingZipCode: true,
    Status: 1,
    Extension: "",
    CountryCode: "",
    TypeShippingAddressModelList: [],
    CreatedBy: currentUser.Id,
  });

  const newFormData = { ...addFormData };

  const [addShipping, setAddShipping] = useState({
    ClientShippingAddressID: 0,
    ClientID: 0,
    ShippingAddress: "",
    ShippingCountryID: 0,
    ShippingStateID: 0,
    SCountryOption: null,
    SStateOption: null,
    ShippingCity: "",
    ShippingZipCode: "",
    IsShippingZipCode: true,
    IsDefault: false,
    Status: 1,
    CreatedBy: currentUser.Id,
    UpdatedBy: currentUser.Id,
    IsDeleted: false,
  });

  const [extraParams, setExtraParams] = useState({
    IsEdit: false,
    EditIndex: -1,
  });

  const newShipping = { ...addShipping };

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  useEffect(() => {
    dispatch(masterActions.GetStateList());
    dispatch(masterActions.GetCountryList());
    dispatch(masterActions.GetClientTypeDrpList());
    dispatch(masterActions.GetClientQuotaDrpList());

    dispatch(clientActions.getClientAll(startEndDate));
  }, [dispatch]);

  const handleRangeDateSearch = () => {
    showLoader();
    if (startEndDate.FromDate && startEndDate.ToDate) {
      dispatch(clientActions.getClientAll(startEndDate));
    } else {
      hideLoader();
      Toastr("Please select the end date", "warning");
    }
  };

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  // const onChangeRangeValue = (title) => (...date) => {
  //     let value = { ...startEndDate };
  //     value.FromDate = date[0];
  //     value.ToDate = date[1];
  //     setStartEndDate(value)
  // }

  const handleEditClick = (Id) => {
    showLoader();
    dispatch(clientActions.getClientById(Id));
    setOpenModal(true);
    setSubmitted(false);
  };

  // Edit Client handleEditClick
  useEffect(() => {
    if (client && client.ClientID > 0) {
      newFormData.ClientID = client.ClientID;
      newFormData.CompanyName = client.CompanyName;
      newFormData.ContactNumber = client.ContactNumber;
      newFormData.ClientTypeID = client.ClientTypeID;
      newFormData.ClientTypeOption = {
        value: client.ClientTypeID,
        label: client.ClientTypeName,
      };
      newFormData.ClientQuotaID = client.ClientQuotaID;

      newFormData.ClientQuotaOption = {
        value: client.ClientQuotaID,
        label: client.ClientQuotaName,
      };

      newFormData.EmailID = client.EmailID;
      newFormData.BillingAddress = client.BillingAddress;
      newFormData.BillingCountryID = client.BillingCountryID;

      let countryOne =
        countryDrpList &&
        countryDrpList.filter((d) => d.value === client.BillingCountryID);
      newFormData.BCountryOption = {
        value: client.BillingCountryID,
        label: countryOne[0] && countryOne[0].label,
      };

      newFormData.BillingStateID = client.BillingStateID;
      let stateOne =
        stateDrpList &&
        stateDrpList.filter((d) => d.value === client.BillingStateID);
      newFormData.BStateOption = {
        value: client.BillingStateID,
        label: stateOne[0] && stateOne[0].label,
      };
      newFormData.BillingCity = client.BillingCity;
      newFormData.ClientSince = client.ClientSince;
      newFormData.BillingZipCode = client.BillingZipCode;
      newFormData.AccountingPOC = client.AccountingPOC;
      newFormData.TaxID = client.TaxID;
      newFormData.FacebookLink = client.FacebookLink;
      newFormData.TwitterLink = client.TwitterLink;
      newFormData.InstagramLink = client.InstagramLink;
      newFormData.SnapchatLink = client.SnapchatLink;
      newFormData.TittokLink = client.TittokLink;
      newFormData.Others = client.Others;
      newFormData.TypeShippingAddressModelList =
        client.ShippingAddressModelList;
      newFormData.Status = client.Status;
      newFormData.IsEmailIDValid = true;
      newFormData.IsContactNumberValid = true;
      newFormData.IsBillingZipCode = true;
      newFormData.Extension = client.Extension;
      let stateList = [...stateDrpList];
      stateList =
        stateList &&
        stateList.filter(
          (d) => d.parentId === parseInt(client.BillingCountryID)
        );
      let CountryCode = [...countryDrpList];
      CountryCode = CountryCode.filter(
        (d) => d.value === client.BillingCountryID
      );

      newFormData.CountryCode = CountryCode[0].parentId;
      setStateList(stateList);
      setAddFormData(newFormData);
      hideLoader();
    }
  }, [client]);

  const handleDeleteClick = (Id) => {
    swal({
      title: "Are you sure, you want to delete this Client?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();
        dispatch(
          clientActions.deleteClient({
            ClientID: Id,
            DeletedBy: currentUser.Id,
          })
        );
      }
    });
  };

  // handleDeleteClick
  useEffect(() => {
    if (deleteClientResponse === 1) {
      hideLoader();
      Toastr("Client deleted successfully", "success");
      dispatch(clientActions.getClientAll(startEndDate));
    } else if (deleteClientResponse === 3) {
      hideLoader();
      Toastr("This Client is already mapped", "warning");
    } else if (deleteClientResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    }
  }, [deleteClientResponse]);

  ///  export  //
  const handleClickPDF = () => {
    let title = "Client List";
    const columnStyles = {
      CompanyName: { halign: "left", cellWidth: 40 },
      EmailID: { halign: "left", cellWidth: 40 },
      ContactNumber: { halign: "center", cellWidth: 40 },
      ClientTypeName: { halign: "left", cellWidth: 40 },
      ClientQuotaName: { halign: "left", cellWidth: 30 },
      CreatedDateString: { halign: "left", cellWidth: 25 },
      StatusName: { halign: "center", cellWidth: 30 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "Client";
    let generateExcelColumns = [
      "Company Name",
      "Email ID",
      "Contact Number",
      "Client Type",
      "Client Quota",
      "Created Date",
      "Status",
    ];
    let new_clientDataList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          CompanyName: obj.CompanyName,
          EmailID: obj.EmailID,
          ContactNumber: obj.ContactNumber,
          ClientTypeName: obj.ClientTypeName,
          ClientQuotaName: obj.ClientQuotaName,
          CreatedDateString: obj.CreatedDateString,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_clientDataList, generateExcelColumns, title);
  };

  // #region Add Client --------------------------------------------------

  const handlePoupClick = () => {
    newFormData.ClientID =
      newFormData.BillingCountryID =
      newFormData.BillingStateID =
      newFormData.ClientQuotaID =
      newFormData.ClientTypeID =
        0;
    newFormData.BillingAddress =
      newFormData.AccountingPOC =
      newFormData.BillingCity =
      newFormData.BillingZipCode =
      newFormData.CompanyName =
      newFormData.ContactNumber =
      newFormData.EmailID =
      newFormData.FacebookLink =
      newFormData.InstagramLink =
      newFormData.Others =
      newFormData.SnapchatLink =
      newFormData.TittokLink =
      newFormData.TwitterLink =
      newFormData.TaxID =
      newFormData.CountryCode =
      newFormData.Extension =
        "";
    newFormData.IsEmailIDValid = true;
    newFormData.IsContactNumberValid = true;
    newFormData.TypeShippingAddressModelList = [];

    newFormData.BCountryOption = null;
    newFormData.BStateOption = null;
    newFormData.ClientTypeOption = null;
    newFormData.ClientQuotaOption = null;
    newFormData.ClientSince = null;
    newFormData.Status = 1;

    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    setStateList([]);
  };

  // handle Change function
  const handleChange = (event, name) => {
    // event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b\s()-]+$/;
    const IsRegexNumber = /^\((\d{3})\)[ ](\d{3})[-](\d{4})$/;
    const nospecial = /^[a-zA-Z0-9]+$/;
    const regexExtensionNumber = /^[0-9\b\s]+$/;
    const Countrylist = [...countryDrpList];

    if (name === "ClientSince") {
      newFormData[name] = event;
    } else {
      const fieldName = event.target.getAttribute("name");
      const fieldValue = event.target.value;
      if (fieldValue && fieldValue.trim()) {
        if (fieldName === "BillingCity") {
          if (fieldValue === "" || regexString.test(fieldValue))
            newFormData[fieldName] = fieldValue;
        } else if (fieldName === "ContactNumber" && fieldValue) {
          if (fieldValue === "" || regexNumber.test(fieldValue)) {
            newFormData[fieldName] = fieldValue;
          }
        } else if (fieldName === "AccountingPOC" && fieldValue) {
          if (fieldValue === "" || nospecial.test(fieldValue)) {
            newFormData[fieldName] = fieldValue;
          }
        } else if (fieldName === "TaxID" && fieldValue) {
          if (fieldValue === "" || nospecial.test(fieldValue)) {
            newFormData[fieldName] = fieldValue;
          }
        } else if (fieldName === "BillingZipCode" && fieldValue) {
          const CountryRow = Countrylist.find(
            (d) => d.value === newFormData.BCountryOption.value
          );
          let ZipCodeLimit;
          try {
            ZipCodeLimit = parseFloat(fieldValue.replace(/\$|,/g, ""));
          } catch {
            ZipCodeLimit = fieldValue;
          }
          ZipCodeLimit = ZipCodeLimit.toString();
          if (CountryRow.value === 233) {
            if (
              fieldValue === "" ||
              (regexNumber.test(fieldValue) && ZipCodeLimit.length <= 5)
            ) {
              newFormData[fieldName] = fieldValue;
            }
          } else {
            if (
              fieldValue === "" ||
              (nospecial.test(fieldValue) && ZipCodeLimit.length <= 6)
            )
              newFormData[fieldName] = fieldValue;
          }
        } else if (fieldName === "Extension") {
          if (fieldValue === "" || regexExtensionNumber.test(fieldValue)) {
            newFormData[fieldName] = fieldValue.replace(/\s/g, "");
          }
        } else {
          newFormData[fieldName] = fieldValue;
        }
      } else {
        newFormData[fieldName] = fieldValue.trim();
      }
      if (fieldName === "EmailID" && fieldName) {
        newFormData.IsEmailIDValid = validator.isEmail(fieldValue);
      } else if (fieldName === "ContactNumber" && fieldValue) {
        newFormData.IsContactNumberValid = !!IsRegexNumber.test(fieldValue);
      }
      // if (fieldName === "BillingZipCode" && fieldValue) {
      //     newFormData.IsBillingZipCode = validator.isPostalCode(fieldValue.toString(), 'US')
      // }
    }

    setAddFormData(newFormData);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "ClientTypeID") {
      newFormData.ClientTypeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "ClientQuotaID") {
      newFormData.ClientQuotaOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "BillingStateID") {
      newFormData.BStateOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "BillingCountryID") {
      newFormData.BCountryOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      if (event.value && parseInt(event.value) > 0) {
        let stateList = [...stateDrpList];
        stateList = stateList.filter(
          (d) => d.parentId === parseInt(event.value)
        );
        setStateList(stateList);
        newFormData.BStateOption = null;
        newFormData.CountryCode = event.parentId;
      }
      if (event.value && parseInt(event.value) !== 233) {
        newFormData.BillingZipCode = "";
      }
      if (event.value && parseInt(event.value) === 233) {
        newFormData.BillingZipCode = "";
      }
    }

    setAddFormData(newFormData);
  };

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();

    var error = false;
    var errorMsg = "";
    if (
      !addFormData.CompanyName ||
      !addFormData.ClientTypeID ||
      !addFormData.ContactNumber ||
      addFormData.ClientQuotaID === 0 ||
      !addFormData.EmailID ||
      !addFormData.BillingAddress ||
      addFormData.BillingCountryID === 0 ||
      addFormData.BillingStateID === 0 ||
      !addFormData.BillingCity ||
      !addFormData.BillingZipCode ||
      !addFormData.AccountingPOC ||
      !addFormData.TaxID ||
      addFormData.IsContactNumberValid === false ||
      addFormData.BStateOption === null
    ) {
      error = true;
    }
    let alertMsg;
    if (
      addFormData.IsEmailIDValid === false ||
      addFormData.IsBillingZipCode === false
    ) {
      Toastr("Please fill in the Data in Valid Form", "warning");
      error = true;
    }
    if (addFormData.BillingZipCode.length < 3) {
      error = true;
      alertMsg = "Please fill in the Data in Valid Form";
    }
    if (addFormData.ContactNumber.length < 10) {
      alertMsg = "please fill in the Phone number in valid form";
    }
    if (addFormData.IsContactNumberValid === false) {
      alertMsg = "Please fill in the ContactNumber in valid form";
    }

    if (
      !addFormData.CompanyName ||
      !addFormData.EmailID ||
      !addFormData.BillingAddress ||
      !addFormData.AccountingPOC ||
      !addFormData.TaxID ||
      addFormData.ClientQuotaID === 0 ||
      addFormData.BillingCountryID === 0 ||
      addFormData.BillingStateID === 0 ||
      !addFormData.BillingCity ||
      !addFormData.BillingZipCode ||
      addFormData.BStateOption === null
    ) {
      alertMsg = "Please fill in the required missing fields";
    }
    if (!error) {
      dispatch(clientActions.saveClient(newFormData));
    } else {
      setSubmitted(true);
      alertMsg && Toastr(`${alertMsg}`, "warning");
    }
  };

  // User Add And Update
  useEffect(() => {
    if (clientResponse === 1) {
      hideLoader();
      Toastr("Client saved successfully", "success");
      dispatch(clientActions.getClientAll(startEndDate));

      setOpenModal(false);
    } else if (clientResponse === 2) {
      hideLoader();
      Toastr("Client updated successfully", "success");

      dispatch(clientActions.getClientAll(startEndDate));
      setOpenModal(false);
    } else if (clientResponse === -1) {
      hideLoader();
      Toastr("Company Name or Email Id already exists ", "warning");
    }
  }, [clientResponse]);

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.ClientID &&
      newFormData.ClientID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.ClientID, DeleteType: 8 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This Client is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  // #endregion Add Client ---------------------------------------

  // #region Add Shipping Address And   Shipping List--------------------------------------------------

  const handleDeleteShipping = (index, ClientShippingAddressID) => {
    if (!ClientShippingAddressID || ClientShippingAddressID === 0) {
      newFormData.TypeShippingAddressModelList.splice(index, 1);
      setAddFormData(newFormData);
    } else {
      // newFormData.TypeShippingAddressModelList[index].IsDeleted = true;
      const allRowData = [...newFormData.TypeShippingAddressModelList];
      const rowData = { ...allRowData[index] };
      rowData.IsDeleted = true;
      const allRowDataflt = allRowData.filter(
        (d) => d.ClientShippingAddressID !== ClientShippingAddressID
      );
      allRowDataflt.push(rowData);
      newFormData.TypeShippingAddressModelList = allRowDataflt;
      setAddFormData(newFormData);
    }
  };

  const handleShippingPoupClick = () => {
    clearShippingDetails();
    setOpenShippingModal(true);
    setStateList([]);
  };

  const clearShippingDetails = () => {
    newShipping.ClientShippingAddressID = 0;
    newShipping.ClientID = 0;
    newShipping.ShippingAddress = "";
    newShipping.ShippingCity = "";
    newShipping.ShippingZipCode = "";
    newShipping.ShippingCountryID = 0;
    newShipping.ShippingStateID = 0;
    newShipping.IsShippingZipCode = true;
    newShipping.SCountryOption = null;
    newShipping.SStateOption = null;
    newShipping.IsDefault = false;
    newShipping.IsDeleted = false;

    setAddShipping(newShipping);

    setSubmittedShipping(false);

    setExtraParams({ IsEdit: false, EditIndex: -1 });
  };

  const handleEditShipping = (index, ClientShippingAddressID) => {
    let editShipData = newFormData.TypeShippingAddressModelList[index];

    newShipping.ClientShippingAddressID = editShipData.ClientShippingAddressID;
    newShipping.ClientID = editShipData.ClientID;
    newShipping.ShippingAddress = editShipData.ShippingAddress;
    newShipping.ShippingCity = editShipData.ShippingCity;
    newShipping.ShippingZipCode = editShipData.ShippingZipCode;
    newShipping.ShippingCountryID = editShipData.ShippingCountryID;
    newShipping.ShippingStateID = editShipData.ShippingStateID;
    newShipping.IsShippingZipCode = editShipData.IsShippingZipCode;
    if (
      ClientShippingAddressID > 0 &&
      editShipData.CountryName &&
      editShipData.StateName
    ) {
      newShipping.SCountryOption = {
        value: editShipData.ShippingCountryID,
        label: editShipData.CountryName,
      };
      newShipping.SStateOption = {
        value: editShipData.ShippingStateID,
        label: editShipData.StateName,
      };
    } else {
      newShipping.SCountryOption = editShipData.SCountryOption;
      newShipping.SStateOption = editShipData.SStateOption;
    }

    newShipping.IsDefault = editShipData.IsDefault;
    newShipping.IsDeleted = editShipData.IsDeleted;
    newShipping.IsShippingZipCode = true;
    let stateList = [...stateDrpList];
    stateList = stateList.filter(
      (d) => d.parentId === parseInt(editShipData.ShippingCountryID)
    );
    setStateList(stateList);

    setAddShipping(newShipping);

    setExtraParams({ IsEdit: true, EditIndex: index });

    setSubmittedShipping(false);
    setOpenShippingModal(true);
  };

  // handle Change function
  const handleShippingChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;
    const nospecial = /^[a-zA-Z0-9]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    //const newFormData = { ...addFormData };
    const CountryList = [...countryDrpList];
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "ShippingCity") {
        if (fieldValue === "" || regexString.test(fieldValue))
          newShipping[fieldName] = fieldValue;
      } else if (fieldName === "ShippingZipCode" && fieldValue) {
        let CountryRow = CountryList.find(
          (d) => d.value === newShipping.SCountryOption.value
        );
        let ZipCodeLimit;
        try {
          ZipCodeLimit = parseFloat(fieldValue.replace(/\$|,/g, ""));
        } catch {
          ZipCodeLimit = fieldValue;
        }
        ZipCodeLimit = ZipCodeLimit.toString();
        if (CountryRow.value === 233) {
          if (
            fieldValue === "" ||
            (regexNumber.test(fieldValue) && ZipCodeLimit.length <= 5)
          ) {
            newShipping[fieldName] = fieldValue;
          }
        } else {
          if (
            fieldValue === "" ||
            (nospecial.test(fieldValue) && ZipCodeLimit.length <= 6)
          )
            newShipping[fieldName] = fieldValue;
        }
      } else {
        newShipping[fieldName] = fieldValue;
      }
    } else {
      newShipping[fieldName] = fieldValue.trim();
    }
    // if (fieldName === "ShippingZipCode" && fieldValue) {
    //     newShipping.IsShippingZipCode = validator.isPostalCode(fieldValue.toString(), 'US')
    // }

    setAddShipping(newShipping);
  };

  // handle Dropdown Change function
  const handleShippingDrpChange = (event, title) => {
    newShipping[title] = event.value && parseInt(event.value);
    if (title === "ShippingStateID") {
      newShipping.SStateOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "ShippingCountryID") {
      newShipping.SCountryOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      if (event.value && parseInt(event.value) > 0) {
        let stateList = [...stateDrpList];
        stateList = stateList.filter(
          (d) => d.parentId === parseInt(event.value)
        );
        setStateList(stateList);
        newShipping.SStateOption = null;
      }
      if (event.value && parseInt(event.value) !== 233) {
        newShipping.ShippingZipCode = "";
      }
      if (event.value && parseInt(event.value) === 233) {
        newShipping.ShippingZipCode = "";
      }
    }
    setAddShipping(newShipping);
  };

  const handleShipCkBoxChange = (event, index, ClientShippingAddressID) => {
    if (event.target.checked) {
      const allRowData = [];
      newFormData.TypeShippingAddressModelList.map((data, j) => {
        const rowData = { ...data };
        if (index === j) {
          rowData.IsDefault = true;
        } else {
          rowData.IsDefault = false;
        }
        allRowData.push(rowData);
      });
      newFormData.TypeShippingAddressModelList = allRowData;
    } else {
      if (ClientShippingAddressID > 0) {
        const allRowData = [...newFormData.TypeShippingAddressModelList];
        const rowData = { ...allRowData[index] };
        rowData.IsDefault = false;
        const allRowDataflt = allRowData.filter(
          (d) => d.ClientShippingAddressID !== ClientShippingAddressID
        );
        allRowDataflt.push(rowData);
        newFormData.TypeShippingAddressModelList = allRowDataflt;
      } else {
        newFormData.TypeShippingAddressModelList[index].IsDefault = false;
      }
    }
    setAddFormData(newFormData);
  };

  const handleAddShipForm = () => {
    var error = false;
    let alertMsg;

    if (
      !newShipping.ShippingAddress ||
      !newShipping.ShippingCity ||
      !newShipping.ShippingZipCode ||
      newShipping.SStateOption === null ||
      !newShipping.ShippingCountryID ||
      newShipping.ShippingCountryID === 0 ||
      !newShipping.ShippingStateID ||
      newShipping.ShippingStateID === 0
    ) {
      error = true;
    }

    if (newShipping.ShippingZipCode.length < 3) {
      error = true;
      alertMsg = "Please fill in the data in valid format";
    }
    if (
      !newShipping.ShippingAddress ||
      !newShipping.ShippingCity ||
      !newShipping.ShippingZipCode ||
      !newShipping.ShippingStateID
    ) {
      alertMsg = "Please fill in the required missing fields";
    }
    if (!error) {
      setOpenShippingModal(false);
      const ShippingList = newFormData.TypeShippingAddressModelList
        ? [...newFormData.TypeShippingAddressModelList]
        : [];

      ShippingList.push(newShipping);
      newFormData.TypeShippingAddressModelList = ShippingList;
    } else {
      setSubmittedShipping(true);
      // Toastr('Please fill in the required missing fields', 'warning');
      // alertMsg = "Please fill in the required missing fields";
      alertMsg && Toastr(`${alertMsg}`, "warning");
    }
    setAddFormData(newFormData);
  };

  const handleUpdateShipForm = () => {
    var error = false;
    let alertMsg;
    if (
      !newShipping.ShippingAddress ||
      !newShipping.ShippingCity ||
      !newShipping.ShippingZipCode ||
      newShipping.SStateOption === null ||
      !newShipping.ShippingCountryID ||
      newShipping.ShippingCountryID === 0 ||
      !newShipping.ShippingStateID ||
      newShipping.ShippingStateID === 0 ||
      newShipping.IsShippingZipCode === false
    ) {
      error = true;
    }
    if (newShipping.ShippingZipCode.length < 3) {
      error = true;
      alertMsg = "Please fill in the data in valid format";
    }
    if (
      !newShipping.ShippingAddress ||
      !newShipping.ShippingCity ||
      !newShipping.ShippingZipCode ||
      !newShipping.ShippingStateID
    ) {
      alertMsg = "Please fill in the required missing fields";
    }
    if (!error) {
      setOpenShippingModal(false);

      const allRowData = [...newFormData.TypeShippingAddressModelList];

      allRowData[extraParams.EditIndex] = { ...newShipping };
      newFormData.TypeShippingAddressModelList = allRowData;
    } else {
      setSubmittedShipping(true);
      alertMsg && Toastr(`${alertMsg}`, "warning");
    }
    setAddFormData(newFormData);
  };

  // #endregion  Add Shipping Address ---------------------------------------

  const CustomInput = (props) => {
    return (
      <>
        <input
          className={`form-control ${
            submitted && !props.value && "border-danger"
          }`}
          onClick={props.onClick}
          value={props.value}
          type="text"
          readOnly={true}
          placeholder="MM/YYYY"
        />
      </>
    );
  };

  return (
    <>
      <PageTitle activeMenu="Manage Client" motherMenu="Users" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Client List</h4>
          <div className="float-sm-end">
            {clientDataList && clientDataList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            {/* <div className="col-lg-3 col-md-8 mb-3">
                            <div className="example rangeDatePicker ms-2">
                                <p className="mb-1 text-black font-w500 productDate">Client Date Range</p>

                                <RangeDatePicker
                                    initialStartDate={startEndDate.FromDate ? startEndDate.FromDate : new Date()}
                                    initialEndDate={startEndDate.ToDate ? startEndDate.ToDate : new Date()}
                                    name="StartEndDate"
                                    startText="Start"
                                    endText="End"
                                    dateFormat="MM/DD/YYYY"
                                    startPlaceholder="Start Date"
                                    endPlaceholder="End Date"
                                    portal
                                    onChange={onChangeRangeValue("date")}

                                />
                            </div>
                        </div> */}
            {/* <div className="col-md-3 mb-2">
                            <div className="d-flex mt-5">
                                <a className="btn btn-primary shadow btn-xs sharp me-1" title="Search" onClick={() => handleRangeDateSearch()} >
                                    <i className="fas fa-search"></i>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp" title="Delete" onClick={() => handleRangeDateClear()} >
                                    <i className="fas fa-times"></i></a>
                            </div>
                        </div> */}
          </div>
          <Table
            columns={columns}
            data={clientDataList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>
      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="xl">
        <Modal.Header>
          <Modal.Title>
            {addFormData && addFormData.ClientID > 0 ? "Edit" : "Add"} Client
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Company Name<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !addFormData.CompanyName && "border-danger"
                  }`}
                  autocomplete="off"
                  name="CompanyName"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.CompanyName}
                  placeholder="Company Name"
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Email ID<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !addFormData.EmailID && "border-danger"
                  }`}
                  autocomplete="off"
                  name="EmailID"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.EmailID}
                  placeholder="Email ID"
                  maxLength={50}
                />
                <span className="validation-text text-danger">
                  {!newFormData.IsEmailIDValid && "Please enter valid Email Id"}
                </span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Contact Number<span className="text-danger">*</span>
              </label>
              <div className="input-group mb-2">
                <div className="input-group-text">
                  +{newFormData.CountryCode}
                </div>
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    (!newFormData.ContactNumber ||
                      newFormData.ContactNumber.length < 14) &&
                    "border-danger"
                  }`}
                  autocomplete="off"
                  name="ContactNumber"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.ContactNumber}
                  maxLength={14}
                  placeholder="(XXX) XXX-XXXX"
                />
              </div>
              <span className="validation-text text-danger">
                {!newFormData.IsContactNumberValid &&
                  "Please enter valid Contact Number eg.(XXX) XXX-XXXX"}
              </span>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">Extension</label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${newFormData.Extension}`}
                  autocomplete="off"
                  name="Extension"
                  required="required"
                  onChange={handleChange}
                  value={newFormData.Extension}
                  maxLength={6}
                  placeholder="Extension"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Client Quota<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <Select
                  name="ClientQuotaID"
                  classNamePrefix={"custom_select_css"}
                  value={newFormData.ClientQuotaOption}
                  onChange={(event) => handleDrpChange(event, "ClientQuotaID")}
                  options={clientQuotaDrpList}
                  styles={
                    submitted &&
                    (!newFormData.ClientQuotaID ||
                      newFormData.ClientQuotaID === 0)
                      ? styles
                      : ""
                  }
                />
                <span className="validation-text"></span>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Client Type<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <Select
                  name="ClientTypeID"
                  classNamePrefix={"custom_select_css"}
                  value={newFormData.ClientTypeOption}
                  onChange={(event) => handleDrpChange(event, "ClientTypeID")}
                  options={clientTypeDrpList}
                  styles={
                    submitted &&
                    (!newFormData.ClientTypeID ||
                      newFormData.ClientTypeID === 0)
                      ? styles
                      : ""
                  }
                />

                <span className="validation-text"></span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4 ">
              <div>
                <label className="text-black font-w500">
                  Client Since<span className="text-danger">*</span>
                </label>
                <div className="contact-name datePicker_Css">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      className={`form-control`}
                      autoOk
                      name="ClientSince"
                      placeholder="MM/YYYY"
                      // format="MM/yyyy"
                      openTo="year"
                      views={["year", "month"]}
                      // inputVariant="outlined"
                      // disableFuture
                      value={newFormData.ClientSince}
                      onChange={(event) => handleChange(event, "ClientSince")}
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          fontSize: 14,
                          height: 48,
                          borderRadius: 13,
                          width: "100%",
                          border:
                            submitted && !addFormData.ClientSince
                              ? "1px solid red"
                              : "1px solid hsl(0,0%,80%)",
                          paddingLeft: "5px",
                        },
                      }}
                      style={{ width: "100%", height: "48px" }}
                      // inputComponent={CustomInput}
                    />
                  </MuiPickersUtilsProvider>

                  {/* <DatePicker
                                        onChange={event => handleChange(event, "ClientSince")}
                                        initialDate={newFormData.ClientSince ? dayjs(new Date(newFormData.ClientSince)) : null}
                                        selected={newFormData.ClientSince ? dayjs(new Date(newFormData.ClientSince)) : null}
                                        placeholder="MM/YYYY"
                                        dateFormat="MM/YYYY"
                                        inputComponent={CustomInput}

                                    /> */}

                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="contact-name">
                <label className="text-black font-w500">
                  Billing Address<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !addFormData.BillingAddress && "border-danger"
                  }`}
                  autocomplete="off"
                  name="BillingAddress"
                  required="required"
                  onChange={handleChange}
                  placeholder="Billing Address"
                  value={newFormData.BillingAddress}
                  maxLength={300}
                />
                <span className="validation-text"></span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Country<span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix={"custom_select_css"}
                name="BillingCountryID"
                value={newFormData.BCountryOption}
                onChange={(event) => handleDrpChange(event, "BillingCountryID")}
                options={countryDrpList}
                styles={
                  submitted &&
                  (!newFormData.BillingCountryID ||
                    newFormData.BillingCountryID === 0)
                    ? styles
                    : ""
                }
              />
              <span className="validation-text"></span>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                State<span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix={"custom_select_css"}
                name="BillingStateID"
                value={newFormData.BStateOption}
                onChange={(event) => handleDrpChange(event, "BillingStateID")}
                options={stateList}
                styles={
                  submitted &&
                  (!newFormData.BillingStateID ||
                    addFormData.BStateOption === null ||
                    newFormData.BillingStateID === 0)
                    ? styles
                    : ""
                }
              />
              <span className="validation-text"></span>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                City<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  submitted && !addFormData.BillingCity && "border-danger"
                }`}
                autocomplete="off"
                name="BillingCity"
                required="required"
                onChange={handleChange}
                placeholder="City"
                value={newFormData.BillingCity}
                maxLength={50}
              />
              <span className="validation-text"></span>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Zip Code<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  submitted &&
                  (!addFormData.BillingZipCode ||
                    addFormData.BillingZipCode.length < 3) &&
                  "border-danger"
                }`}
                autocomplete="off"
                value={addFormData.BillingZipCode}
                name="BillingZipCode"
                required="required"
                onChange={handleChange}
                maxLength={6}
                placeholder="Zip Code"
              />
              <span className="validation-text text-danger">
                {!newFormData.IsBillingZipCode && "Please enter valid Zip Code"}
              </span>
            </div>
          </div>
          <h4 style={{ color: "#00A3DA" }}>Shipping Address</h4>

          <Modal
            className="fade bd-example-modal-lg"
            show={isOpenShippingModal}
            size="lg"
          >
            <Modal.Header>
              <Modal.Title>
                {extraParams.IsEdit === true ? "Edit" : "Add"} Shipping Address
              </Modal.Title>
              <Button
                variant=""
                className="btn-close"
                onClick={() => setOpenShippingModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              {/* <h4 style={{ color: "#00A3DA" }}>Shipping Address</h4> */}

              <div className="row">
                <div className="col-md-12 mb-4">
                  <label className="text-black font-w500">
                    Shipping Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={newShipping.ShippingAddress}
                    className={`form-control ${
                      submittedShipping &&
                      !newShipping.ShippingAddress &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="ShippingAddress"
                    required="required"
                    onChange={(e) => handleShippingChange(e)}
                    placeholder="Shipping Address"
                    maxLength={300}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <label className="text-black font-w500">
                    Country<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="ShippingCountryID"
                    value={newShipping.SCountryOption}
                    onChange={(event) =>
                      handleShippingDrpChange(event, "ShippingCountryID")
                    }
                    options={countryDrpList}
                    styles={
                      submittedShipping &&
                      (!newShipping.ShippingCountryID ||
                        newShipping.ShippingCountryID === 0)
                        ? styles
                        : ""
                    }
                  />
                  <span className="validation-text"></span>
                </div>
                <div className="col-md-6 mb-4">
                  <label className="text-black font-w500">
                    State<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="ShippingStateID"
                    value={newShipping.SStateOption}
                    onChange={(event) =>
                      handleShippingDrpChange(event, "ShippingStateID")
                    }
                    options={stateList}
                    styles={
                      submittedShipping &&
                      (!newShipping.ShippingStateID ||
                        newShipping.ShippingStateID === 0 ||
                        newShipping.SStateOption === null)
                        ? styles
                        : ""
                    }
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <label className="text-black font-w500">
                    City<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={newShipping.ShippingCity}
                    className={`form-control ${
                      submittedShipping &&
                      !newShipping.ShippingCity &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="ShippingCity"
                    required="required"
                    onChange={(e) => handleShippingChange(e)}
                    placeholder="City"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
                <div className="col-md-6 mb-4">
                  <label className="text-black font-w500">
                    Zip Code<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={newShipping.ShippingZipCode}
                    className={`form-control ${
                      submittedShipping &&
                      (!newShipping.ShippingZipCode ||
                        newShipping.ShippingZipCode.length < 3) &&
                      "border-danger"
                    }`}
                    autocomplete="off"
                    name="ShippingZipCode"
                    required="required"
                    onChange={(e) => handleShippingChange(e)}
                    maxLength={6}
                    placeholder="Zip Code"
                  />
                  <span className="validation-text text-danger">
                    {!newShipping.IsShippingZipCode &&
                      "Please enter valid Zip Code"}
                  </span>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="danger light"
                onClick={() => setOpenShippingModal(false)}
              >
                Close
              </Button>
              <Button
                variant=""
                onClick={
                  extraParams.IsEdit === false
                    ? () => handleAddShipForm()
                    : () => handleUpdateShipForm()
                }
                className="btn btn-primary"
              >
                {extraParams.IsEdit === true ? "Update" : "Add"}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal.Footer>
            {" "}
            <Button
              variant=""
              onClick={handleShippingPoupClick}
              className="btn btn-primary"
            >
              Add Shipping Address
            </Button>
          </Modal.Footer>

          <div className="card-body">
            <div className="col-12">
              <div className="table-responsive">
                <div id="job_data" className="dataTables_wrapper">
                  <table
                    className="display w-100 dataTable "
                    id="example5"
                    role="grid"
                    aria-describedby="example5_info"
                  >
                    <thead>
                      <tr role="row">
                        <th className="sorting" style={{ width: "30px" }}>
                          Default
                        </th>
                        <th className="sorting_asc" style={{ width: "350px" }}>
                          Shipping Address
                        </th>

                        <th className="sorting" style={{ width: "200px" }}>
                          City
                        </th>
                        <th className="sorting" style={{ width: "128px" }}>
                          State
                        </th>
                        <th className="sorting" style={{ width: "46px" }}>
                          Country
                        </th>
                        <th className="sorting" style={{ width: "46px" }}>
                          Zip Code
                        </th>
                        <th className="sorting" style={{ width: "46px" }}>
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {newFormData &&
                      newFormData.TypeShippingAddressModelList &&
                      newFormData.TypeShippingAddressModelList.length > 0 ? (
                        <>
                          {newFormData &&
                            newFormData.TypeShippingAddressModelList.filter(
                              (d) => d.IsDeleted === false
                            ).map((inputField, index) => (
                              <Fragment key={`${inputField}~${index}`}>
                                <tr className="odd" role="row">
                                  <td className="sorting_1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={inputField.IsDefault}
                                      onChange={(event) =>
                                        handleShipCkBoxChange(
                                          event,
                                          index,
                                          inputField.ClientShippingAddressID
                                        )
                                      }
                                    />
                                  </td>

                                  <td className="sorting_1">
                                    {inputField.ShippingAddress}
                                  </td>
                                  <td>{inputField.ShippingCity}</td>
                                  <td>
                                    {inputField.ClientShippingAddressID > 0 &&
                                    inputField.StateName
                                      ? inputField.StateName
                                      : inputField.SStateOption.label}
                                  </td>
                                  <td>
                                    {inputField.ClientShippingAddressID > 0 &&
                                    inputField.CountryName
                                      ? inputField.CountryName
                                      : inputField.SCountryOption.label}
                                  </td>
                                  <td>{inputField.ShippingZipCode}</td>
                                  <td>
                                    <div className="d-flex">
                                      <a
                                        className="btn btn-primary shadow btn-xs sharp me-1"
                                        onClick={(e) =>
                                          handleEditShipping(
                                            index,
                                            inputField.ClientShippingAddressID
                                          )
                                        }
                                        title="Edit"
                                      >
                                        <i className="fas fa-pen"></i>
                                      </a>
                                      <a
                                        className="btn btn-danger shadow btn-xs sharp"
                                        onClick={(e) =>
                                          handleDeleteShipping(
                                            index,
                                            inputField.ClientShippingAddressID
                                          )
                                        }
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              </Fragment>
                            ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="11" className="norecordfound">
                            <span>No Records Found</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Accounting POC<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !addFormData.AccountingPOC && "border-danger"
                  }`}
                  autocomplete="off"
                  name="AccountingPOC"
                  required="required"
                  onChange={handleChange}
                  placeholder="Accounting POC"
                  value={newFormData.AccountingPOC}
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">
                Tax ID<span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${
                    submitted && !addFormData.TaxID && "border-danger"
                  }`}
                  autocomplete="off"
                  name="TaxID"
                  required="required"
                  onChange={handleChange}
                  placeholder="Tax ID"
                  value={newFormData.TaxID}
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
            </div>
          </div>
          <h4 style={{ color: "#00A3DA" }}>Social Media</h4>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">Facebook</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fab fa-facebook-f"></i>{" "}
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="FacebookLink"
                  placeholder="Facebook "
                  onChange={handleChange}
                  value={newFormData.FacebookLink}
                  name="FacebookLink"
                  maxLength={50}
                />
                <div
                  id="val-username1-error"
                  className="invalid-feedback animated fadeInUp"
                  style={{ display: "block" }}
                />
              </div>
              <span className="validation-text"></span>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">twitter</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fab fa-twitter"></i>{" "}
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="TwitterLink"
                  placeholder="twitter "
                  name="TwitterLink"
                  onChange={handleChange}
                  value={newFormData.TwitterLink}
                  maxLength={50}
                />
                <div />
              </div>
              <span className="validation-text"></span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">Instagram</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fab fa-instagram"></i>{" "}
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="InstagramLink"
                  placeholder="Instagram "
                  name="InstagramLink"
                  onChange={handleChange}
                  value={newFormData.InstagramLink}
                  maxLength={50}
                />
                <div />
              </div>
              <span className="validation-text"></span>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">Snapchat</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fab fa-snapchat"></i>{" "}
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="SnapchatLink"
                  placeholder="Snapchat"
                  name="SnapchatLink"
                  onChange={handleChange}
                  value={newFormData.SnapchatLink}
                  maxLength={50}
                />
                <div />
              </div>
              <span className="validation-text"></span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">Tiktok</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fab fa-tiktok"></i>{" "}
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="TittokLink"
                  placeholder="Tiktok"
                  name="TittokLink"
                  onChange={handleChange}
                  value={newFormData.TittokLink}
                  maxLength={50}
                />
                <div />
              </div>
              <span className="validation-text"></span>
            </div>
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500">Others</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fab fa-opera"></i>{" "}
                  {/* <i className="fa-thin fa-user-plus"></i> */}
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="Others"
                  placeholder="Others"
                  name="Others"
                  onChange={handleChange}
                  value={newFormData.Others}
                  maxLength={50}
                />
                <div />
              </div>
              <span className="validation-text"></span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-5">
              <label className="text-black font-w500">Active</label>
              <div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    name="Status"
                    checked={newFormData.Status === 1 ? true : false}
                    onChange={(event) => handleCkBoxChange(event, "Status")}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            className="btn btn-primary"
          >
            {addFormData.ClientID && addFormData.ClientID > 0
              ? "Update"
              : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
      {loader}
    </>
  );
};

export default ClientList;
